interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const statusStyles: Record<string, string> = {
  active: 'badge-success',
  healthy: 'badge-success',
  inactive: 'badge-gray',
  pending: 'badge-warning',
  suspended: 'badge-danger',
  unhealthy: 'badge-danger',
  degraded: 'badge-warning',
  unknown: 'badge-gray',
  // Estados de pedido (ecommerce)
  confirmed: 'badge-info',
  processing: 'badge-info',
  shipped: 'badge-info',
  delivered: 'badge-success',
  cancelled: 'badge-danger',
  // Estados de pago (ecommerce)
  paid: 'badge-success',
  failed: 'badge-danger',
  refunded: 'badge-gray',
};

const statusLabels: Record<string, string> = {
  active: 'Activo',
  healthy: 'Saludable',
  inactive: 'Inactivo',
  pending: 'Pendiente',
  suspended: 'Suspendido',
  unhealthy: 'No saludable',
  degraded: 'Degradado',
  unknown: 'Desconocido',
  // Estados de pedido (ecommerce)
  confirmed: 'Confirmado',
  processing: 'En proceso',
  shipped: 'Enviado',
  delivered: 'Entregado',
  cancelled: 'Cancelado',
  // Estados de pago (ecommerce)
  paid: 'Pagado',
  failed: 'Fallido',
  refunded: 'Reembolsado',
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const style = statusStyles[status] || 'badge-gray';
  const label = statusLabels[status] || status;

  return (
    <span className={`${style} ${size === 'sm' ? 'text-xs px-2 py-0.5' : ''}`}>
      {label}
    </span>
  );
}
